// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1QvsZ","alertIcon":"ConfirmModal_alertIcon__BScXi"};